<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.noCache"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.noCache"></router-view>
    <!-- <router-view /> -->
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
.bc81871a44ea566dd738 {
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}


html,body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 500px) {
  .el-message {
    min-width: 300px !important;
  }
}

@media screen and (max-width: 500px) {
  .el-message-box{
    width: 300px !important;
  }
}

img {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE10+/Edge */
  user-select: none;         /* 标准语法 */
  filter:blur(0);
	-webkit-filter:blur(0);
	-moz-filter:blur(0);
	-ms-filter:blur(0);
	transform:translateZ(0);
	-webkit-transform:translateZ(0);
	-moz-transform:translateZ(0);
	-ms-transform:translateZ(0);
}
/* @media screen and (max-width: 500px) {
   .el-dialog__wrapper .el-dialog {
      width: 300px !important;
      .el-dialog__body{
        padding: 10px 20px!important;
        .el-form-item__label{
          width: 68px!important;
        }
        .el-select,.el-input{
          width: 180px!important;
        }
      }
    }
} */
/* #app {
  filter: invert(1) hue-rotate(180deg);
} */
</style>


// WEBPACK FOOTER //
// src/App.vue